/**
 * Lightweight content fingerprints for stale-anchor detection.
 * Prefer Web Crypto when available; fall back to a stable FNV-1a hex.
 */

export function foldPersian(s: string): string {
  return String(s ?? "")
    .replace(/[\u200c\u200d\u200e\u200f\ufeff\u00a0]/g, "")
    .replace(/ي/g, "ی")
    .replace(/ك/g, "ک")
    .replace(/ة/g, "ه")
    .replace(/ؤ/g, "و")
    .replace(/[أإآ]/g, "ا")
    .replace(/\s+/g, " ")
    .trim();
}

/** Sync FNV-1a 32-bit → 8 hex chars (good enough for section etags). */
export function hashTextSync(text: string): string {
  const folded = foldPersian(text);
  let h = 0x811c9dc5;
  for (let i = 0; i < folded.length; i++) {
    h ^= folded.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, "0");
}

export async function hashText(text: string): Promise<string> {
  return hashTextSync(text);
}

export function hashesMatch(
  expected: string | undefined,
  actualText: string
): boolean {
  if (!expected) return true;
  return expected === hashTextSync(actualText);
}
